// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"34bcc649","869":"5643786c"}[chunkId] + ".chunk.css";
};